import { useState, useEffect } from 'react';
import { Box, Typography, Card, Chip, Table, TableHead, TableRow, TableCell, TableBody, Button, Stack } from '@mui/material';
import authFetch from '../utils/authFetch';
import { tbl, typo } from '../styles/ds';

const METHOD_HE = {
  POST:   { label: 'יצירה',  bg: '#D4EDDA', color: '#155724' },
  PUT:    { label: 'עדכון',  bg: '#CCE5FF', color: '#004085' },
  DELETE: { label: 'מחיקה',  bg: '#F8D7DA', color: '#721C24' },
};

const ENTITY_HE = {
  customers: 'לקוחות', orders: 'הזמנות', order_items: 'פריטי הזמנה', payments: 'תשלומים',
  products: 'מוצרים', variants: 'וריאנטים', leads: 'לידים', suppliers: 'ספקים',
  workers: 'עובדים', purchases: 'רכישות', production_batches: 'ייצור', users: 'משתמשים',
  activities: 'פעילויות', tags: 'תגיות', attributes: 'תכונות',
};

const PAGE = 50;
const fmtDateTime = iso => iso ? new Date(iso).toLocaleString('he-IL', { dateStyle: 'short', timeStyle: 'medium' }) : '—';

// Admin-only view of audit_log (who did what, when)
const AuditLogPage = () => {
  const [rows, setRows]   = useState(null);
  const [page, setPage]   = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    authFetch(`/audit_log?_start=${page * PAGE}&_end=${(page + 1) * PAGE}`)
      .then(async r => {
        const range = r.headers.get('Content-Range');
        if (range) setTotal(Number(range.split('/')[1]) || 0);
        return r.json();
      })
      .then(d => setRows(Array.isArray(d) ? d : []))
      .catch(() => setRows([]));
  }, [page]);

  return (
    <Box className="crm-page" p={3}>
      <Typography {...typo.pageTitle} mb={1}>יומן פעולות</Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        תיעוד אוטומטי של כל פעולות היצירה, העדכון והמחיקה במערכת (סיסמאות מוסתרות).
      </Typography>

      {rows === null ? (
        <Typography color="text.secondary">טוען...</Typography>
      ) : rows.length === 0 ? (
        <Typography color="text.secondary">אין פעולות מתועדות עדיין</Typography>
      ) : (
        <>
          <Card sx={{ borderRadius: 2, overflow: 'hidden', mb: 2 }}>
            <Box data-mobile-scroll sx={{ overflowX: 'auto' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">מתי</TableCell>
                    <TableCell>מי</TableCell>
                    <TableCell align="center">פעולה</TableCell>
                    <TableCell>אזור</TableCell>
                    <TableCell>נתיב</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((r, i) => {
                    const m = METHOD_HE[r.method] || { label: r.method, bg: '#eee', color: '#333' };
                    return (
                      <TableRow key={r.id} sx={tbl.bodyRow(i)}>
                        <TableCell align="center" sx={{ fontSize: 12, color: 'text.secondary', whiteSpace: 'nowrap' }}>
                          {fmtDateTime(r.created_at)}
                        </TableCell>
                        <TableCell sx={{ fontSize: 13, fontWeight: 600 }}>{r.username || '—'}</TableCell>
                        <TableCell align="center">
                          <Chip label={m.label} size="small"
                            sx={{ height: 20, fontSize: 10, fontWeight: 700, backgroundColor: m.bg, color: m.color }} />
                        </TableCell>
                        <TableCell sx={{ fontSize: 13 }}>
                          {ENTITY_HE[r.entity] || r.entity || '—'}{r.entity_id ? ` #${r.entity_id}` : ''}
                        </TableCell>
                        <TableCell sx={{ fontSize: 12, color: 'text.secondary', direction: 'ltr' }}>{r.path}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Card>
          <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
            <Button size="small" disabled={page === 0} onClick={() => setPage(p => p - 1)}>הקודם</Button>
            <Typography fontSize={13} color="text.secondary">
              עמוד {page + 1} מתוך {Math.max(1, Math.ceil(total / PAGE))}
            </Typography>
            <Button size="small" disabled={(page + 1) * PAGE >= total} onClick={() => setPage(p => p + 1)}>הבא</Button>
          </Stack>
        </>
      )}
    </Box>
  );
};

export default AuditLogPage;
